var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearchRed(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.51743 8.69324L12.0158 11.1911L11.1904 12.0165L8.6926 9.51807C7.7632 10.2631 6.60718 10.6684 5.41601 10.6667C2.51802 10.6667 0.166016 8.31466 0.166016 5.41666C0.166016 2.51866 2.51802 0.166656 5.41601 0.166656C8.31401 0.166656 10.666 2.51866 10.666 5.41666C10.6677 6.60782 10.2625 7.76384 9.51743 8.69324ZM8.34726 8.26041C9.08758 7.49909 9.50102 6.47857 9.49935 5.41666C9.49935 3.16032 7.67176 1.33332 5.41601 1.33332C3.15968 1.33332 1.33268 3.16032 1.33268 5.41666C1.33268 7.67241 3.15968 9.49999 5.41601 9.49999C6.47793 9.50166 7.49845 9.08822 8.25976 8.34791L8.34726 8.26041Z",
    fill: "#E72649"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchRed);
export default __webpack_public_path__ + "static/media/search-red.fad60191764a65e33966ca9ef7cd746d.svg";
export { ForwardRef as ReactComponent };